/** Explicit user operation; fresh CAS + readback, never automatic write retries. */
export type CropCollectionTarget={collectionId:string;libraryId:string;versionId:string;purpose:string;renditionId:string|null;expectedRevision?:number;allowAdd?:boolean};
type Request=(path:string,options?:any)=>Promise<any>;
export function variantMatches(c:any,t:CropCollectionTarget){
 const item=c.items?.find((i:any)=>i.version_id===t.versionId);
 return Boolean(item&&(t.renditionId===null?!item.collection_variant:item.collection_variant?.rendition_id===t.renditionId&&item.collection_variant?.purpose===t.purpose));
}
function problem(message:string,status?:number,latest?:any){return Object.assign(new Error(message),{status,latest})}
export async function bindCropVariant(request:Request,t:CropCollectionTarget,onCheckpoint?:(collection:any)=>void){
 const url='/collections/'+encodeURIComponent(t.collectionId),readUrl=url+'?purpose='+encodeURIComponent(t.purpose);
 const read=async()=>{
  const c=await request(readUrl);
  if(c.id!==t.collectionId||c.library_id!==t.libraryId||!Number.isInteger(c.revision)||!Array.isArray(c.items))throw problem('Kolekce neodpovídá zvolenému cíli.');
  return c;
 };
 let c=await read();
 // A previous confirmed or uncertain write may already have completed.
 if(variantMatches(c,t))return c;
 if(t.expectedRevision!==undefined&&c.revision!==t.expectedRevision)throw problem('Kolekci mezitím změnil někdo jiný. Načti aktuální kolekci a zkontroluj změny.',409,c);
 onCheckpoint?.(c);
 if(!c.items.some((i:any)=>i.version_id===t.versionId)){
  if(!t.allowAdd)throw problem('Fotografie již není v této kolekci.',409,c);
  let error:any,ack:any;
  try{ack=await request(url+'/items?purpose='+encodeURIComponent(t.purpose),{method:'PUT',body:{versions:[...c.items.map((i:any)=>i.version_id),t.versionId],expected_revision:c.revision}})}catch(e){error=e}
  if(error&&[401,403,404].includes(error.status))throw error;
  const added=await read();
  if(!added.items.some((i:any)=>i.version_id===t.versionId))throw error||problem('Přidání fotografie není potvrzené. Zkontroluj kolekci před dalším pokusem.');
  if(error)throw problem('Fotografie je v kolekci, ale odpověď přidání nebyla potvrzená. Zkontroluj kolekci a znovu přiřaď uloženou variantu.',error.status,added);
  if(added.revision!==ack?.revision)throw problem('Kolekce se po přidání fotografie změnila. Zkontroluj změny před přiřazením varianty.',409,added);
  c=added;
  onCheckpoint?.(c);
 }
 let error:any;
 try{await request(url+'/variants/'+encodeURIComponent(t.versionId),{method:'PUT',body:{rendition_id:t.renditionId,purpose:t.purpose,expected_revision:c.revision}})}catch(e){error=e}
 if(error&&[401,403,404].includes(error.status))throw error;
 const verified=await read();
 if(!variantMatches(verified,t))throw problem(error?.message||'Přiřazení varianty není potvrzené. Zkontroluj aktuální kolekci a zkus přiřazení znovu.',error?.status,verified);
 return verified;
}
